import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import AppShowcase from '../components/AppShowcase';
import './HomePage.css';

function HomePage() {
  const { t } = useLanguage();

  useEffect(() => {
    document.title = t('home.meta.title');
  }, [t]);

  return (
    <div className="home-page">
      <header className="home-hero">
        <p className="home-hero-eyebrow">{t('home.eyebrow')}</p>
        <h1>{t('home.title')}</h1>
        <p className="home-hero-subtitle">{t('home.subtitle')}</p>
        <Link to="/support" className="home-hero-cta">
          {t('home.cta')}
        </Link>
      </header>

      <h2 className="home-section-title">{t('home.appsTitle')}</h2>
      <AppShowcase />
    </div>
  );
}

export default HomePage;
